import React, { useState } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import axios from "axios";

import { Header, StatsPanel } from "../components";
import routes from "../routes/routes";
import { useHistory, useLocation } from "react-router-dom";
import { withAuthHeader } from "../routes/authRequest";

const EditUser = () => {
    const { state: { user } } = useLocation()
const history  = useHistory() 
    const { register, handleSubmit, errors } = useForm();
    const [message, setMessage] = useState("");
    const mutation = useMutation(userData => withAuthHeader.post(routes.api.locations.editMember, userData))

    const onSubmit = async (inputData) => {
        await mutation.mutate({ ...inputData, id: user.id }, {
            onSuccess: async (inputData) => {
                setMessage(["user updated"])
                console.log("response", inputData);
                setTimeout(() => {
                    history.push(routes.public.users)
                }, 2000);
            },
            onError: async (error) => {
                setMessage(["Something went wrong, please try again"])
            },
        })
        console.log(inputData);
    };

    // console.log(location);
    return (
        <div className="mainpanel">
            {/* <!-- pageheader --> */}
            <Header />

            <div className="contentpanel">
                {/* <div className="row row-stat">
                    <StatsPanel
                        icon="fa fa-dollar"
                        value="NGN 98,102,766"
                        yesterday="NGN 98,102,766"
                        color="panel-success-alt"
                        title="TOTAL EARNINGS"
                    />
                    <StatsPanel
                        icon="fa fa-users"
                        value="NGN 1,102,544"
                        yesterday="NGN 1,098,544"
                        color="panel-primary"
                        title="TODAY'S EARNINGS"
                    />
                    <StatsPanel
                        icon="fa fa-pencil"
                        value="3,102"
                        yesterday="3,101"
                        color="panel-dark"
                        title="TOTAL USERS"
                    />
                </div> */}

                <div className="col-md-10 col-md-offset-1">
                    <form className="panel panel-default" onSubmit={handleSubmit(onSubmit)}>
                        <p className="text-success">{message[0]}</p>

                        <div className="panel-heading">
                            <div className="panel-btns">
                                <a
                                    href="/#"
                                    className="panel-minimize tooltips"
                                    data-toggle="tooltip"
                                    title="Minimize Panel"
                                >
                                    <i className="fa fa-minus">-</i>
                                </a>
                                <a
                                    href="/#"
                                    className="panel-close tooltips"
                                    data-toggle="tooltip"
                                    title="Close Panel"
                                >
                                    <i className="fa fa-times"></i>
                                    X
                </a>
                            </div>
                            {/* <!-- panel-btns --> */}
                            <h4 className="panel-title">Edit user</h4>
                            <p>Edit a member by filling and submitting the form.</p>
                        </div>
                        {/* <!-- panel-heading --> */}
                        <div className="panel-body">
                            <div className="row">
                                <div className="form-group col-md-6">
                                    <label>Email</label>
                                    <input
                                        type="text"
                                        name="email"
                                        placeholder="Email"
                                        className="form-control"
                                        defaultValue={user.email}
                                        ref={register({
                                            required: "This input is required.",
                                        })}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="email"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>

                                <div className="form-group col-md-6">
                                    <label>Phone Number</label>
                                    <input
                                        type="text"
                                        name="phone_no"
                                        placeholder="Phone Number"
                                        defaultValue={user.phone_no}
                                        className="form-control"
                                        ref={register()}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="phone_no"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label>Address</label>
                                    <input
                                        type="text"
                                        name="address"
                                        placeholder="Address"
                                        className="form-control"
                                        defaultValue={user.address}
                                        ref={register({
                                            required: "This input is required.",
                                        })}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="address"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label>Financial Status</label>
                                    {/* <div className="input-group"> */}
                                        <input
                                            type="text"
                                            className="form-control hasDatepicker"
                                            placeholder="Financial Status"
                                            id="datepicker"
                                            name="financial_status"
                                            defaultValue={user.financial_status}
                                            ref={register({
                                                required: "This input is required.",
                                            })}
                                        />
                                        {/* <span className="input-group-addon">
                                            <i className="glyphicon glyphicon-calendar"></i>
                                        </span> */}
                                    {/* </div> */}
                                    <ErrorMessage
                                        errors={errors}
                                        name="financial_status"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label>Section</label>
                                    {/* <div className="input-group"> */}
                                        <input
                                            type="text"
                                            className="form-control hasDatepicker"
                                            placeholder="Section"
                                            id="datepicker"
                                            name="sections"
                                            defaultValue={user.sections || "none"}
                                            ref={register({
                                                required: "This input is required.",
                                            })}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="sections"
                                            render={(messages) => {
                                                console.log("messages", messages);
                                                return messages
                                                    ? Object.entries(messages).map(([type, message]) => (
                                                        <p className="text-danger">{message}</p>
                                                    ))
                                                    : null;
                                            }}
                                        />
                                        {/* <span className="input-group-addon">
                                            <i className="glyphicon glyphicon-calendar"></i>
                                        </span> */}
                                    {/* </div> */}
                                </div>
                                <div className="form-group col-md-6">
                                    <label>Role</label>
                                    {/* <div className="input-group"> */}
                                        <input
                                            type="text"
                                            className="form-control hasDatepicker"
                                            placeholder="Role"
                                            id="datepicker"
                                            name="role"
                                            defaultValue={user.role}
                                            ref={register({
                                                required: "This input is required.",
                                            })}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="role"
                                            render={(messages) => {
                                                console.log("messages", messages);
                                                return messages
                                                    ? Object.entries(messages).map(([type, message]) => (
                                                        <p className="text-danger">{message}</p>
                                                    ))
                                                    : null;
                                            }}
                                        />
                                        {/* <span className="input-group-addon">
                                            <i className="glyphicon glyphicon-calendar"></i>
                                        </span> */}
                                    {/* </div> */}
                                </div>
                            </div>
                            {/* <!-- row --> */}
                        </div>
                        {/* <!-- panel-body --> */}
                        <div className="panel-footer">
                            <button type="submit" className="btn btn-primary">Update user</button>
                        </div>
                        {/* <!-- panel-footer --> */}
                    </form>
                    {/* <!-- panel --> */}
                </div>
            </div>
        </div>
    );
};

export default EditUser;
